import React, { FC } from 'react';
import { UserInfoStyle } from './UserInfo.jss';
import { useAccount, useMsal } from '@azure/msal-react';
import { LogoutOutlined } from '@ant-design/icons';
import { Button, Space, Tooltip } from 'antd';

const UserInfo: FC = () => {
    const style = UserInfoStyle();

    const { accounts, instance } = useMsal();
    const account = useAccount(accounts[0] || {});

    const handleLogout = () => {
        instance.logoutRedirect();
    };

    return (
        <>
            <div className={style.userInfoStyle}>
                <Space direction="horizontal">
                    <div>
                        <div className={style.userNameStyle}>{account?.name}</div>
                        <div className={style.emailStyle}>{account?.username}</div>
                    </div>
                    <Tooltip title="Cerrar Sesión">
                        <Button type="primary" shape="circle" icon={<LogoutOutlined />} onClick={handleLogout} />
                    </Tooltip>
                </Space>
            </div>
        </>
    );
};

export default UserInfo;
